export default __webpack_public_path__ + "static/media/gloves-icon.3f86cb29.svg";